import React, { Component } from 'react';
import { SegmentedControl } from 'segmented-control-react';
import './App.css';

const segments = ['All', 'Unread', 'Drafts', 'Trash', 'Pins'];

function handleChange(index) {
    document.getElementById('selected-segment').innerHTML = `Selected Segment : ${segments[index]}`;
}

class App extends Component {
    state = {
        variant: 'base'
    };

    changeVariant = (variant) => {
        this.setState({variant: variant});
    }

    render() {
        return (
        <div className={this.state.variant === 'light' ? 'light-app':'App'}>
            <SegmentedControl            
                segments={segments}
                selected={0} 
                variant={this.state.variant}    
                onChangeSegment={handleChange}           
            />  
            <p id="selected-segment">Selected Segment : All</p>  
            <hr/>
            <p>Toggle Variant</p> 
            <button className="base" onClick={ (e) => this.changeVariant('base')}>Base</button>
            <button className="dark" onClick={ (e) => this.changeVariant('dark')}>Dark</button>
            <button className="success" onClick={ (e) => this.changeVariant('success')}>Success</button>
            <button className="error" onClick={ (e) => this.changeVariant('error')}>Error</button>
            <button className="light" onClick={ (e) => this.changeVariant('light')}>Light</button>
        </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js